import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

import { AppComponent } from './app/app.component';
import { routing } from './app/app-routing.module';
import { WingsMobileModule } from './app/wings-mobile/wings-mobile.module';
import { JwtInterceptor } from './app/wings-mobile/Jwt.Interceptor';
import { environment } from './environments/environment';
import 'hammerjs';

// Preserve the Ford blue (#1c5d9d) primary palette on top of the Lara preset,
// which is the successor of the legacy "lara-light-blue" theme, so the UI
// matches the previous look and feel (spacing, fonts, radius, sizes).
const FordLara = definePreset(Lara, {
	semantic: {
		primary: {
			50: '#e9f1f8',
			100: '#c8dcec',
			200: '#a4c4df',
			300: '#7fabd2',
			400: '#5896c8',
			500: '#1c5d9d',
			600: '#195389',
			700: '#154674',
			800: '#11395f',
			900: '#0d2c49',
			950: '#081d31'
		}
	}
});

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(routing, BrowserModule, BrowserAnimationsModule, FormsModule, WingsMobileModule, RouterModule),
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		providePrimeNG({
			theme: {
				preset: FordLara,
				options: {
					darkModeSelector: false,
					cssLayer: {
						name: 'primeng',
						order: 'primeng'
					}
				}
			}
		})
	]
})
	.then(() => {
		if ('serviceWorker' in navigator && environment.production) {
			navigator.serviceWorker.register('./ngsw-worker.js');
		}
	})
	.catch(err => console.error(err));

if((navigator as any).userAgentData.mobile){
	document.body.requestFullscreen();
	(screen.orientation as any).lock("portrait-primary");
}

